import React from 'react';
import DashboardV3 from './DashboardV3/DashboardV3';

const MainDashboard = props => <DashboardV3 {...props} />

export default MainDashboard;
